
import { Link } from "react-router-dom";
import { FileText, Shield, Euro, Scale } from "lucide-react";

const LegalFooter = () => {
  return (
    <footer className="mt-8 pt-6 border-t border-ice-white/10">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex flex-col items-center space-y-4">
          <div className="flex flex-wrap items-center justify-center gap-6">
            <Link 
              to="/pricing" 
              className="flex items-center space-x-2 text-ice-white/60 hover:text-ice-white transition-colors"
            >
              <Euro className="w-4 h-4" />
              <span className="text-sm">Pricing</span>
            </Link>
            <Link 
              to="/cancellation-rights" 
              className="flex items-center space-x-2 text-ice-white/60 hover:text-ice-white transition-colors"
            >
              <Scale className="w-4 h-4" />
              <span className="text-sm">Cancellation Rights</span>
            </Link>
            <Link 
              to="/terms-of-service" 
              className="flex items-center space-x-2 text-ice-white/60 hover:text-ice-white transition-colors"
            >
              <FileText className="w-4 h-4" />
              <span className="text-sm">Terms of Service</span>
            </Link>
            <Link 
              to="/privacy-policy" 
              className="flex items-center space-x-2 text-ice-white/60 hover:text-ice-white transition-colors"
            >
              <Shield className="w-4 h-4" />
              <span className="text-sm">Privacy Policy</span>
            </Link>
          </div>
          <div className="text-center">
            <p className="text-xs text-ice-white/40">
              © 2025 ALPHA. All rights reserved.
            </p>
            <p className="text-xs text-ice-white/30 mt-1">
              Kfir Yehuda, Fuggerstraße 9, 10777 Berlin
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LegalFooter;
